import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Input,
  Tabs,
  Modal,
} from "antd";
import {
  MensajeError,
  dineroDisabledMask,
  Form,
  FormItem,
  SelectItem,
  NotificacionPolizas,
  DatePickerItem,
  InputItem,
  ButtonItem,
  SwitchItem,
  ErrorItem,
  TextAreaItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import {
  PlusOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
  CarOutlined,
  UserOutlined,
  ContactsOutlined,
} from "@ant-design/icons";
import ElegirTipoDeCliente from "../../Clientes/ElegirTipoDeCliente/ElegirTipoDeCliente";
import facturaPdf from "../../../../Pdf/facturaPdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreo from "../MandarCorreo/MandarCorreo";
import VistaPreviaVenta from "../VistaPreviaVenta/VistaPreviaVenta";
import InfoCard from "../../../../Components/InfoCard";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import { tabStyles } from "../../../../Components/TabbedDynamicTable";
import TabEntregaDireccion from "../../../../Components/TabEntregaDireccion";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import FormListLeyendasFiscales from "../../../../Components/FormListLeyendasFiscales";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs

class GenerarFactura extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    datosVenta: undefined,
    objetoUsosDeCFDI: null,
    todasUsosDeCFDI: null,
    modalElegirTipoDeCliente: false,
    modalElegirTipoDeClienteId: null,
    modalElegirTipoDeClienteNombre: null,
    modalCorreo: false,
    modalCorreoId: null,
    modalVistaPrevia: false,
    datosVistaPrevia: null,
    complementoDetallista: false,
    usarLeyendasFiscales: false,
    detallista: null,
    id: this.props.location.state.id,
    todasRegimenFiscal: null,
    objetoRegimenFiscal: null,
    activarRegimenes: false,
    todasRegimenFiscalCliente: [],
    objetoRegimenFiscalCliente: [],
    todasFormasDePago: [],
    objetoFormasDePago: [],
    contado: 1,
    fechaServidor: null,
    facturaFechaAnterior: false,
    direccionesCliente: [],
    objetoDireccionesCliente: null,
    addendaMabe: false,
    addendaViscofan: false,
    addendaContinental: false,
    addendaGoodyear: false,
    loadingEntrega: false,
    loadingPlantasEntrega: {},
    todasPaises: [],
    todasEstado: [],
    todasMunicipios: [],
    todasColonias: [],
    objetoPaises: null,
    objetoEstados: null,
    objetoMunicipios: null,
    objetoColonias: null,
    objetoPlantasEntrega: {},
    todasSeriesVenta: [],
  };

  // Hora real, tomada del servidor al cargar la pantalla (no depende del reloj de la computadora)
  horaServidor = () => this.state.fechaServidor ? this.state.fechaServidor.clone() : moment();

  componentDidMount() {
    this.consultarTodo();
    if (
      this.props.complementoSeriesPersonalizadas &&
      this.props.permisoElegirSerieFolioPersonalizado
    ) {
      this.consultarSeriesVenta();
    }
  }

  consultarSeriesVenta() {
    axios
      .post(
        "serieventas/selectSeriesVentaActivas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const series = Array.isArray(res.data) ? res.data : [];
        this.setState({ todasSeriesVenta: series });
      });
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "usodecfdi/selectUsosDeCFDI",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUsosDeCFDI: res.data });
          this.setState({
            objetoUsosDeCFDI: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value?.c_UsoCFDI + ' - ' + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "ventas/datosVentaPRecibirP",
        {
          empresaId: this.props.empresaId,
          ventaId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion de la venta");
        } else {
          const fechaServidor = res.data.fechaServidor ? moment(res.data.fechaServidor) : null;
          this.setState({
            fechaServidor,
            facturaFechaAnterior: res.data.facturaFechaAnterior,
            objetoRegimenFiscalCliente: res.data.regimenesFiscales?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
            todasRegimenFiscalCliente: res.data.regimenesFiscales,
            objetoFormasDePago: res.data.formasDePago.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_FormaPago + " - " + value.descripcion}
                </Option>
              );
            }),
            todasFormasDePago: res.data.formasDePago,
            datosVenta: res.data.venta,
            insumos: res.data.insumos,
            complementoDetallista: res.data.venta.cliente.complementoDetallista,
            contado: res.data.venta.contado,
            detallista: {
              orderIdentification: res.data.venta.cliente.orderIdentification,
              referenceDateOrderIdentification: res.data.venta.cliente.referenceDateOrderIdentification,
              additionalInformation: res.data.venta.cliente.additionalInformation,
              deliveryNote: res.data.venta.cliente.deliveryNote,
              referenceDateDeliveryNote: res.data.venta.cliente.referenceDateDeliveryNote,
            },
            direccionesCliente: res.data.venta.cliente.direcciones,
            objetoDireccionesCliente: res.data.venta.cliente.direcciones?.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
                </Option>
              );
            }),
            addendaMabe: res.data.venta.cliente.usarAdenda && res.data.venta.cliente.adendaActiva === "Mabe",
            addendaViscofan: res.data.venta.cliente.usarAdenda && res.data.venta.cliente.adendaActiva === "Viscofan",
            addendaContinental: res.data.venta.cliente.usarAdenda && res.data.venta.cliente.adendaActiva === "Continental",
            addendaGoodyear: res.data.venta.cliente.usarAdenda && res.data.venta.cliente.adendaActiva === "Goodyear",
            usarLeyendasFiscales: !!res.data.venta.cliente.usarLeyendasFiscales,
          });
          this.formRef.current.setFieldsValue({
            usoDeCfdiId: res.data.venta.cliente.usoDeCFDIID,
            regimenClienteFiscalId: res.data.venta?.cliente?.regimenFiscalId,
            formaDePagoId: res.data.venta?.formaDePagoId,
            ordenDeCompra: res.data.venta?.ordenDeCompra,
            req: res.data.venta?.req,
            atencion: res.data.venta?.atencion,
            observaciones: res.data.venta?.observaciones,
            observaciones2: res.data.venta?.observaciones2,
            imprimirObservaciones: res.data.venta?.imprimirObservaciones,
            direccionEntrega: res.data.venta?.direccionEntrega,
            // El snapshot de la remision gana; si nunca se capturo, el default del cliente
            leyendasFiscales: res.data.venta?.leyendasFiscales?.length
              ? res.data.venta.leyendasFiscales
              : (res.data.venta.cliente?.leyendasFiscales || []),
            fechaVenta: fechaServidor || moment()
          });
        }
      });

    await axios
      .post(
        "ventas/selectDatosParaRegimen",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            objetoRegimenFiscal: res.data.regimenesFiscales.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.c_RegimenFiscal + " - " + value.descripcion}
                </Option>
              );
            }),
            activarRegimenes: res.data.activarRegimenes,
            todasRegimenFiscal: res.data.regimenesFiscales,
          });
          if (res.data.activarRegimenes) {
            this.formRef.current.setFieldsValue({ regimenFiscalId: res.data.regimenDefaultId })
          }
        } else {
          message.warning("No se encontraron datos de regimenes fiscales");
        }
      });


    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (this.state.datosVenta?.facturaAjustadaPorDevolucion) {
      const insumosExcluidos = this.state.datosVenta.insumosExcluidos || [];
      const catalogoInsumos = this.state.insumos || [];
      Modal.confirm({
        title: "Esta factura excluirá insumos devueltos",
        width: 520,
        content: (
          <div>
            <p>
              Esta remisión tiene una devolución ya compensada contra la deuda. La factura se
              generará <b>excluyendo</b> las cantidades devueltas:
            </p>
            <ul>
              {insumosExcluidos.map((valueInsumo) => {
                const insumoCatalogo = catalogoInsumos.find(
                  (i) => i._id?.toString() === valueInsumo.insumoId?.toString()
                );
                return (
                  <li key={valueInsumo._id}>
                    {insumoCatalogo?.descripcion || valueInsumo.insumoId}: -{valueInsumo.cantidadExcluida}
                  </li>
                );
              })}
            </ul>
            <p>
              Total ajustado: <b>{dineroDisabledMask(this.state.datosVenta.totalAjustado)}</b>
              {" "}(original {dineroDisabledMask(this.state.datosVenta.total)})
            </p>
            <p>¿Deseas continuar y generar la factura con el total ajustado?</p>
          </div>
        ),
        okText: "Sí, generar factura ajustada",
        cancelText: "Cancelar",
        onOk: () => this.enviarFactura(values),
      });
      return;
    }
    this.enviarFactura(values);
  }
  enviarFactura(values) {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/generarFactura",
        {
          ...values,
          empresaId: this.props.empresaId,
          ventaId: this.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha generado una factura de la venta");
          if (res.data.avisoPolizas) message.warning(res.data.avisoPolizas, 8);

          if (window.registrarMovimiento) {
            const dataSat = res.data.respuestaFactura.dataSat;
            const nombreArchivo = (dataSat.Serie ? dataSat.Serie : 'F') + ' - ' + dataSat.Folio + ' ( ' + dataSat.Receptor.Rfc + ' - ' + dataSat.Receptor.Nombre + ' )';

            window.registrarMovimiento({
              titulo: 'Factura Emitida',
              mensaje: `${nombreArchivo} - Haga click para descargar`,
              icono: 2,
              onClick: () => {
                var xmltext = res.data.respuestaFactura.data.cfdi;

                var filename = nombreArchivo + ".xml";
                var pom = document.createElement("a");
                var bb = new Blob([xmltext], { type: "text/plain" });

                pom.setAttribute("href", window.URL.createObjectURL(bb));
                pom.setAttribute("download", filename);

                pom.dataset.downloadurl = [
                  "text/plain",
                  pom.download,
                  pom.href,
                ].join(":");
                pom.draggable = true;
                pom.classList.add("dragout");

                pom.click();

                const datosParaPdf = {
                  ...res.data,
                  remisionNumero: this.state.datosVenta.remisionNumero
                };
                //const pdf = facturaPdf(res.data);
                const pdf = facturaPdf(datosParaPdf);

                pdfMake.createPdf(pdf).download(nombreArchivo + ".pdf");
              },
            });
          }

          NotificacionPolizas(res.data.polizasId)
          this.setState({ modalCorreo: true, modalCorreoId: res.data.ventaId })
        } else if (res.data.success === 1) {
          MensajeError({
            message: res.data.errorTimbrado?.titulo || res.data.message || "No se puede generar la factura",
            description: res.data.errorTimbrado?.mensaje || res.data.description,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
        } else {
          message.error("Hubo un error y no se genero la factura");
        }
      });
  }
  // Se valida igual que al generar, para que la vista previa sea la factura que se va a timbrar
  abrirVistaPrevia() {
    this.formRef.current
      .validateFields()
      .then((values) => {
        this.setState({
          modalVistaPrevia: true,
          datosVistaPrevia: {
            ...values,
            ventaId: this.state.id,
            // Lo usa `enviarVentaPreview` para mandar el correo al cliente de la factura
            clienteId: values.cambiarCliente ? values.clienteFacturaId : this.state.datosVenta?.clienteId,
          },
        });
      })
      .catch(this.onFinishFailed);
  }
  atras() {
    this.props.history.goBack();
  }
  agregarCliente() {
    this.props.history.push("/panel/agregarCliente");
  }
  onChangeCliente(valueId, cliente) {
    if (!cliente) return;
    if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
      message.info('No se podra facturar a este cliente. Faltan datos')
    }
    if (!cliente.tipoClienteId) {
      const nombre = cliente.persona
        ? cliente.razonSocial
        : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
      this.abrirElegirTipoDeCliente(cliente._id, nombre);
    }
    this.setState({
      complementoDetallista: cliente.complementoDetallista,
      detallista: {
        orderIdentification: cliente.orderIdentification,
        referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
        additionalInformation: cliente.additionalInformation,
        deliveryNote: cliente.deliveryNote,
        referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
      },
      direccionesCliente: cliente.direcciones,
      objetoDireccionesCliente: cliente.direcciones?.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
          </Option>
        );
      }),
      addendaMabe: cliente.usarAdenda && cliente.adendaActiva === "Mabe",
      addendaViscofan: cliente.usarAdenda && cliente.adendaActiva === "Viscofan",
      addendaContinental: cliente.usarAdenda && cliente.adendaActiva === "Continental",
      addendaGoodyear: cliente.usarAdenda && cliente.adendaActiva === "Goodyear",
      usarLeyendasFiscales: !!cliente.usarLeyendasFiscales,
    })
    this.formRef.current.setFieldsValue({
      usoDeCfdiId: cliente.usoDeCFDIID,
      regimenClienteFiscalId: cliente.regimenFiscalId,
      leyendasFiscales: cliente.usarLeyendasFiscales ? (cliente.leyendasFiscales || []) : [],
    });
  }
  abrirElegirTipoDeCliente(id, nombre) {
    this.setState({
      modalElegirTipoDeCliente: true,
      modalElegirTipoDeClienteId: id,
      modalElegirTipoDeClienteNombre: nombre,
    });
  }
  cerrarElegirTipoDeCliente(elegido) {
    if (!elegido) {
      this.formRef.current.setFieldsValue({ clienteFacturaId: undefined });
    }
    this.consultarTodo();
    this.setState({
      modalElegirTipoDeCliente: false,
      modalElegirTipoDeClienteId: null,
      modalElegirTipoDeClienteNombre: null,
    });
  }
  cerrarMandarCorreo() {
    this.setState({
      modalCorreo: false,
      modalCorreoId: null,
    });
    this.formRef.current.resetFields();
    this.atras();
  }
  onChangeCambiarCliente(value) {
    if (!value) {
      const cliente = this.state.datosVenta.cliente;
      this.setState({
        complementoDetallista: cliente.complementoDetallista,
        detallista: {
          orderIdentification: cliente.orderIdentification,
          referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
          additionalInformation: cliente.additionalInformation,
          deliveryNote: cliente.deliveryNote,
          referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
        },
        direccionesCliente: cliente.direcciones,
        objetoDireccionesCliente: cliente.direcciones?.map((value) => {
          return (
            <Option value={value._id} key={value._id}>
              {(value.calle || "Sin calle") + ' ' + (value.numeroCalle || "Sin número") + (value.numeroInterior ? ' Int. ' + value.numeroInterior : '') + ', ' + (value.colonia || "Sin colonia")}
            </Option>
          );
        }),
        addendaMabe: cliente.usarAdenda && cliente.adendaActiva === "Mabe",
        addendaViscofan: cliente.usarAdenda && cliente.adendaActiva === "Viscofan",
        addendaContinental: cliente.usarAdenda && cliente.adendaActiva === "Continental",
        addendaGoodyear: cliente.usarAdenda && cliente.adendaActiva === "Goodyear",
        usarLeyendasFiscales: !!cliente.usarLeyendasFiscales,
      });
      this.formRef.current.setFieldsValue({
        leyendasFiscales: this.state.datosVenta?.leyendasFiscales?.length
          ? this.state.datosVenta.leyendasFiscales
          : (cliente.usarLeyendasFiscales ? (cliente.leyendasFiscales || []) : []),
      });
    } else {
      this.setState({
        complementoDetallista: false,
        usarLeyendasFiscales: false,
      })
      this.formRef.current.setFieldsValue({ leyendasFiscales: [] });
    }
  }
  async onChangeEstado(value, inicial) {
    if (!inicial) {
      this.formRef.current.setFieldsValue({
        direccionEntrega: {
          municipioId: undefined,
          coloniaId: undefined
        }
      });
    }
    await axios
      .post(
        "municipios/selectMunicipios",
        { estadoId: value },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          let objetoMunicipios = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            );
          });
          this.setState({
            todasMunicipios: res.data,
            objetoMunicipios: objetoMunicipios,
          });
        }
      });
  }

  async onChangeMunicipio(value, inicial) {
    await axios
      .post(
        "colonias/selectColonias",
        { municipioId: value },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          let objetoColonias = res.data.map((value) => {
            return (
              <Option value={value._id} key={value._id}>
                {value.cp + " - " + value.nombre}
              </Option>
            );
          });
          this.setState({
            todasColonias: res.data,
            objetoColonias: objetoColonias,
          });
        }
      });
  }

  async onSearchColonia(value) {
    if (value.toString().length === 5) {
      await axios
        .post(
          "colonias/buscarCP",
          { cp: value },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.info("No se encontro el codigo postal");
          } else {
            this.formRef.current.setFieldsValue({
              direccionEntrega: {
                paisId: res.data.paisId,
                estadoId: res.data.estadoId,
                municipioId: res.data.municipioId
              }
            });
            this.onChangeEstado(res.data.estadoId, true);
            this.onChangeMunicipio(res.data.municipioId, true);
          }
        });
    }
  }

  async onSelectColoniaId(coloniaId, fieldKey) {
    const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
    if (!direccionEntrega?.colonia) {
      const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
      await this.formRef.current.setFieldsValue({
        direccionEntrega: {
          colonia: nombreColonia
        }
      })
    }
  }

  handleDireccionEntregaChange(direccionValues) {
    if (direccionValues) {
      this.formRef.current?.setFieldsValue({
        direccionEntrega: direccionValues
      });
      this.setState({
        direccionEntregaData: direccionValues
      });
    }
  }

  async handleChangeDireccionEntrega(value) {
    this.setState({ loadingEntrega: true })
    if (value) {
      const direccion = this.state.direccionesCliente.find((direccion) => direccion._id.toString() === value.toString())
      if (direccion) {
        if (direccion.estadoId) {
          await this.onChangeEstado(direccion.estadoId, true);
        }
        if (direccion.municipioId) {
          await this.onChangeMunicipio(direccion.municipioId, true);
        }
        if (direccion.plantaEntregaId) {
          this.onSearchPlantaEntrega(direccion.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
        }
        this.formRef.current.setFieldsValue({
          direccionEntrega: {
            paisId: direccion.paisId,
            estadoId: direccion.estadoId,
            municipioId: direccion.municipioId,
            coloniaId: direccion.coloniaId,
            colonia: direccion.colonia,
            calle: direccion.calle,
            numeroCalle: direccion.numeroCalle,
            numeroInterior: direccion.numeroInterior,
            descripcion: direccion.descripcion,
            telefono: direccion.telefono,
            correo: direccion.correo,
            observaciones: direccion.observaciones,
            plantaEntregaId: direccion.plantaEntregaId,
            referencia: direccion.referencia,
            clienteNombre: direccion?.clienteNombre,
            clienteRfc: direccion?.clienteRfc
          }
        })
      }
    }
    this.setState({ loadingEntrega: false })
  }

  onSearchPlantaEntrega = (value, fieldKey, opts = {}) => {
    const { byId = false, setSelected = false } = opts;
    if (byId) {
      axios
        .post(
          "plantaDeEntrega/selectPlantaEntregaPorId",
          { id: value },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          const p = res?.data?.dato || null;
          if (!p || !p._id) {
            this.setState(prev => ({
              objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
              loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
            }));
            message.warning("No se encontró la planta por ID.");
            return;
          }

          const option = (
            <Option key={p._id} value={p._id} padre={p.plantaEntregaId}>
              {p.label}
            </Option>
          );

          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [option] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));

          if (setSelected && (this.props.form?.setFieldsValue || this.form?.setFieldsValue)) {
            const form = this.props.form || this.form;
            form.setFields([
              { name: ['"direccionEntrega"', fieldKey, 'plantaEntregaId'], value: p._id }
            ]);
          }
        })
        .catch((err) => {
          console.error(err);
          message.error("Error al buscar planta por ID");
          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));
        });

      return;
    }
    this.setState(prev => ({
      loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: true }
    }));
    axios
      .post(
        "plantaDeEntrega/selectPlantasDeEntrega",
        { query: value || "" },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res?.data.success !== 2) {
          this.setState(prev => ({
            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
          }));
          return;
        }
        const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
        const options = items.map(it => (
          <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
            {it.label}
          </Option>
        ));

        this.setState(prev => ({
          objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: options },
          loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
        }));
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al buscar plantas de entrega");
        this.setState(prev => ({
          objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
          loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
        }));
      });
  }

  consultarInformacionEntrega() {
    if (this.state.todasPaises.length > 0) return
    this.setState({ loadingEntrega: true })
    const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");

    axios.post("direcciones/selectInformacionDomicilio", { direccion: direccionEntrega }, {
      headers: this.props.headersToken
    })
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loadingEntrega: false,
            todasPaises: res.data.paises,
            todasEstado: res.data.estados,
            todasMunicipios: res.data.municipios,
            todasColonias: res.data.colonias,
            objetoMunicipios: res.data.municipios.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            objetoColonias: res.data.colonias.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.cp + " - " + value.nombre}
                </Option>
              );
            }),
            objetoPaises: res.data.paises.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
            objetoEstados: res.data.estados.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviatura}
                </Option>
              );
            }),
          })
        } else {
          message.info("No se encontró información para entrega")
          this.setState({
            loadingEntrega: false
          })
        }
      })
  }

  onChangeTab(key) {
    if (key === "3") {
      this.consultarInformacionEntrega();
    }
  }

  renderEncabezado() {
    const venta = this.state.datosVenta;
    if (!venta) return null;
    const proyecto = venta.proyecto || {};
    const cliente = venta.cliente || {};
    const nombreCliente = cliente.nombre
      ? `${cliente.nombre} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim()
      : cliente.razonSocial;
    return (
      <Row style={{ marginBottom: 16 }}>
        <InfoCard
          title="PROYECTO"
          icon={<InfoCircleOutlined />}
          accentColor="#00BFD6"
          compact
          sections={[
            {
              title: "Información General",
              icon: <InfoCircleOutlined />,
              iconColor: "#00BFD6",
              lg: 12,
              items: [
                { label: "Nombre", value: proyecto.nombre || "-" },
                { label: "Descripción", value: proyecto.descripcion || "-" },
              ],
            },
            {
              title: proyecto.calle ? "Dirección de envío" : "Vehículo",
              icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
              iconColor: "#C9DF00",
              lg: 12,
              items: proyecto.calle
                ? [
                    { label: "Calle", value: proyecto.calle || "-" },
                    { label: "Número", value: proyecto.numeroCalle || "-" },
                  ]
                : [
                    { label: "Marca", value: proyecto.marca || "-" },
                    { label: "Modelo", value: proyecto.modelo || "-" },
                    { label: "Placas", value: proyecto.placas || "-" },
                  ],
            },
          ]}
          splitWith={{
            title: "CLIENTE",
            icon: <UserOutlined />,
            accentColor: "#FF6A0D",
            compact: true,
            sections: [
              {
                title: "Datos del Cliente",
                icon: <UserOutlined />,
                iconColor: "#FF6A0D",
                lg: 12,
                items: [
                  { label: "Nombre", value: nombreCliente || "-" },
                  { label: "RFC", value: cliente.rfc || "-" },
                  { label: "Correo", value: cliente.correo || "-" },
                  { label: "Teléfono", value: cliente.telefono || "-" },
                  { label: "Celular", value: cliente.celular || "-" },
                ],
              },
              {
                title: "Contacto",
                icon: <ContactsOutlined />,
                iconColor: "#00BFD6",
                lg: 12,
                items: [
                  { label: "Contacto", value: cliente.nombreContacto || "-" },
                  { label: "Tel. Contacto", value: cliente.telefonoContacto || "-" },
                  { label: "Correo Contacto", value: cliente.correoContacto || "-" },
                  { label: "Días de crédito", value: cliente.diasCredito || "-" },
                ],
              },
            ],
          }}
        />
      </Row>
    );
  }

  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Generar Factura sobre Venta"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <h1 style={{ fontWeight: 700 }}>
              Fecha:{moment(this.state.datosVenta?.fechaVenta ? this.state.datosVenta?.fechaVenta : this.state.datosVenta?.createdAt).format("LL")}
            </h1>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="generarFacturaventa"
              layout
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              {this.renderEncabezado()}
              <style>{tabStyles}</style>
              <div style={{ maxWidth: "100%", width: "100%", margin: "0 auto", position: "relative" }}>
                <Tabs
                  defaultActiveKey={1}
                  tabBarStyle={{ background: "transparent", margin: 0, padding: "0 16px", minHeight: "auto" }}
                  className="custom-tabs"
                  onChange={this.onChangeTab.bind(this)}
                >
                  <TabPane
                    tab={<span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>General</span>}
                    tabKey={1}
                    key={1}
                    forceRender
                  >
                  <Row gutter={[16, 16]}>
                        {this.state.activarRegimenes && (
                          <DynamicCardForm xs={24} sm={24} lg={16} xl={16} title="Régimen Fiscal">
                            <FormItem
                              label="Regimen Fiscal"
                              name="regimenFiscalId"
                              margin
                              required
                              labelCol={{ span: 6 }}
                              wrapperCol={{ span: 18 }}
                            >
                              <SelectItem placeholder="Regimen Fiscal">
                                {this.state.objetoRegimenFiscal}
                              </SelectItem>
                            </FormItem>
                          </DynamicCardForm>
                        )}
                        <DynamicCardForm xs={24} sm={24} lg={8} xl={8} title="Fecha de Factura">
                          <FormItem
                            label="Fecha:"
                            name="fechaVenta"
                            required
                            margin
                            initialValue={moment()}
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            {(() => {
                              const permitirFechaAnterior = this.state.facturaFechaAnterior;
                              const fechaMinima = this.horaServidor().subtract(72, "hours");
                              const fechaMaxima = this.horaServidor();
                              const rangoHoras = (inicio, fin) => Array.from({ length: Math.max(fin - inicio, 0) }, (_, i) => inicio + i);
                              return (
                                <DatePickerItem
                                  disabled={!this.state.facturaFechaAnterior}
                                  showTime={permitirFechaAnterior || undefined}
                                  dateFormat={permitirFechaAnterior ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY"}
                                  disabledDate={permitirFechaAnterior ? (current) => current && (current < fechaMinima.clone().startOf("day") || current > fechaMaxima.clone().endOf("day")) : undefined}
                                  disabledTime={permitirFechaAnterior ? (current) => {
                                    if (!current) return {};
                                    if (current.isSame(fechaMinima, "day")) {
                                      return {
                                        disabledHours: () => rangoHoras(0, fechaMinima.hour()),
                                        disabledMinutes: (hora) => hora === fechaMinima.hour() ? rangoHoras(0, fechaMinima.minute()) : [],
                                        disabledSeconds: (hora, minuto) => hora === fechaMinima.hour() && minuto === fechaMinima.minute() ? rangoHoras(0, fechaMinima.second()) : [],
                                      };
                                    }
                                    if (current.isSame(fechaMaxima, "day")) {
                                      return {
                                        disabledHours: () => rangoHoras(fechaMaxima.hour() + 1, 24),
                                        disabledMinutes: (hora) => hora === fechaMaxima.hour() ? rangoHoras(fechaMaxima.minute() + 1, 60) : [],
                                        disabledSeconds: (hora, minuto) => hora === fechaMaxima.hour() && minuto === fechaMaxima.minute() ? rangoHoras(fechaMaxima.second() + 1, 60) : [],
                                      };
                                    }
                                    return {};
                                  } : undefined}
                                  placeholder="Fecha de Factura"
                                  allowClear={false}
                                />
                              );
                            })()}
                          </FormItem>
                        </DynamicCardForm>
                        {this.props.complementoSeriesPersonalizadas && this.props.permisoElegirSerieFolioPersonalizado && this.state.todasSeriesVenta.length > 0 && (
                          <DynamicCardForm xs={24} sm={24} lg={8} xl={8} title="Serie">
                            <FormItem
                              label="Serie"
                              name="serieVentaId"
                              margin
                              labelCol={{ span: 8 }}
                              wrapperCol={{ span: 16 }}
                            >
                              <SelectItem placeholder="Selecciona una serie (opcional)" allowClear>
                                {this.state.todasSeriesVenta.map((serie) => (
                                  <Option value={serie._id} key={serie._id}>
                                    {`${serie.nombre} (${serie.serieFacturas}/${serie.serieRemisiones}) - Sig. Factura: ${serie.folioFacturas ?? 1}`}
                                  </Option>
                                ))}
                              </SelectItem>
                            </FormItem>
                          </DynamicCardForm>
                        )}
                        <DynamicCardForm xs={24} lg={24} title="Datos Cliente">
                          <FormItem
                            name="cambiarCliente"
                            label="Cambiar Cliente"
                            margin
                            valuePropName="checked"
                            initialValue={false}
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <SwitchItem onChange={(value) => this.onChangeCambiarCliente(value)} />
                          </FormItem>
                          <FormItem shouldUpdate noStyle labelCol={{ span: 7 }} wrapperCol={{ span: 14 }}>
                            {({ getFieldValue }) => {
                              const cambiarCliente = getFieldValue("cambiarCliente");
                              if (cambiarCliente) {
                                return (
                                  <FormItem margin label="Cliente">
                                    <Input.Group compact>
                                      <FormItem
                                        name="clienteFacturaId"
                                        noStyle
                                        required
                                      >
                                        <SelectClientesItem
                                          empresaId={this.props.empresaId}
                                          headersToken={this.props.headersToken}
                                          ventaId={this.state.id}
                                          onChange={this.onChangeCliente.bind(this)}
                                          placeholder="Cliente"
                                          width="80%"
                                        />
                                      </FormItem>
                                      <ButtonItem
                                        icon={<PlusOutlined />}
                                        style={{ width: "20%" }}
                                        onClick={this.agregarCliente.bind(this)}
                                      />
                                    </Input.Group>
                                  </FormItem>
                                );
                              }
                            }}
                          </FormItem>
                          <FormItem
                            label="Regimen Fiscal Cliente"
                            name="regimenClienteFiscalId"
                            margin
                            required
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <SelectItem placeholder="Regimen Fiscal Cliente">
                              {this.state.objetoRegimenFiscalCliente}
                            </SelectItem>
                          </FormItem>
                          <FormItem
                            name="formaDePagoId"
                            label="F Pago"
                            margin
                            required
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <SelectItem disabled={this.state.contado === 2} placeholder="Forma de Pago">
                              {this.state.objetoFormasDePago}
                            </SelectItem>
                          </FormItem>
                          <FormItem
                            name="usoDeCfdiId"
                            label="Uso de CFDI"
                            margin
                            required
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <SelectItem placeholder="Uso de CFDI">
                              {this.state.objetoUsosDeCFDI}
                            </SelectItem>
                          </FormItem>
                          <FormItem
                            name="ordenDeCompra"
                            label="O Compra"
                            margin
                            pattern
                            required={this.state.addendaGoodyear}
                            tooltip={this.state.addendaGoodyear
                              ? "La Orden de Compra es el único dato que se manda en la adenda Goodyear"
                              : undefined}
                             labelCol={{ span: 7 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <InputItem placeholder="Orden de Compra" />
                          </FormItem>
                          <FormItem
                            name="req"
                            label="Req"
                            margin
                            pattern
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <InputItem placeholder="Requisición" />
                          </FormItem>
                          <FormItem
                            name="atencion"
                            label="Atención a"
                            margin
                            pattern
                            required={this.state.addendaContinental}
                            tooltip={this.state.addendaContinental
                              ? "Se manda como Solicitante en la adenda Continental. Captura el correo del solicitante, ej: comprador@conti.com.mx"
                              : "Indica a quién dirigir este documento."}
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 14 }}
                          >
                            <InputItem placeholder={this.state.addendaContinental ? "Solicitante, ej: comprador@conti.com.mx" : "Atención a"} />
                          </FormItem>
                        </DynamicCardForm>
                        <DynamicCardForm xs={24} lg={24} title="Observaciones">
                          <FormItem
                            name="observaciones"
                            label="Observaciones"
                            margin
                            pattern
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                          >
                            <TextAreaItem rows={3} placeholder="Observaciones" />
                          </FormItem>
                          <FormItem
                            name="observaciones2"
                            label="Obs. Internas"
                            margin
                            pattern
                            tooltip="Estas observaciones no se imprimirán en la venta."
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                          >
                            <TextAreaItem rows={3} placeholder="Observaciones Internas" />
                          </FormItem>
                          <FormItem
                            name="imprimirObservaciones"
                            label="Imprimir Observaciones"
                            margin
                            valuePropName="checked"
                            initialValue={false}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                          >
                            <SwitchItem />
                          </FormItem>
                        </DynamicCardForm>
                  </Row>
                </TabPane>
                {(this.state.complementoDetallista && this.props.complementoDetallista) ?
                  <TabPane
                    tab={<span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>Detallista</span>}
                    tabKey={2}
                    key={2}
                    forceRender
                  >
                    <Row>
                      <DynamicCardForm span={24} title="Complemento Detallista">
                        {this.state?.detallista?.orderIdentification &&
                          <FormItem
                            name="orderIdentification"
                            label="OrderIdentification"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                            required
                          >
                            <InputItem placeholder="OrderIdentification" />
                          </FormItem>
                        }
                        {this.state?.detallista?.referenceDateOrderIdentification &&
                          <FormItem
                            name="referenceDateOrderIdentification"
                            label="ReferenceDateOrderIdentification"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                            required
                          >
                            <DatePickerItem placeholder="ReferenceDateOrderIdentification" />
                          </FormItem>
                        }
                        {this.state?.detallista?.additionalInformation &&
                          <FormItem
                            name="typeAdditionalInformation"
                            label="TypeAdditionalInformation"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                            required
                          >
                            <SelectItem
                              placeholder="Type - AdditionalInformation"
                            >
                              <Option value="AAE">AAE - Cuenta predial</Option>
                              <Option value="CK">CK - Número de cheque</Option>
                              <Option value="ACE">ACE - Numero de documento(Remisión)</Option>
                              <Option value="ATZ">ATZ - Número de aprobación.</Option>
                              <Option value="AWR">AWR - Numero de documento que  se reemplaza</Option>
                              <Option value="ON">ON - Número de pedido (comprador)</Option>
                              <Option value="DQ">DQ - Folio de recibo de mercancías</Option>
                              <Option value="IV">IV - Número de Factura</Option>
                            </SelectItem>
                          </FormItem>
                        }
                        {this.state?.detallista?.additionalInformation &&
                          <FormItem
                            name="referenceIdentificationAdditionalInformation"
                            label="ReferenceIdentification"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                            required
                          >
                            <InputItem placeholder="ReferenceIdentification - AdditionalInformation" />
                          </FormItem>
                        }
                        {this.state?.detallista?.deliveryNote &&
                          <FormItem
                            name="deliveryNote"
                            label="DeliveryNote"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                            required
                          >
                            <InputItem placeholder="DeliveryNote" />
                          </FormItem>
                        }
                        {this.state?.detallista?.referenceDateDeliveryNote &&
                          <FormItem
                            name="referenceDateDeliveryNote"
                            label="ReferenceDateDeliveryNote"
                            margin
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                            required
                          >
                            <DatePickerItem placeholder="ReferenceDateDeliveryNote" />
                          </FormItem>
                        }
                      </DynamicCardForm>
                    </Row>
                  </TabPane>
                  : null}
                {this.state.usarLeyendasFiscales ?
                  <TabPane
                    tab={<span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>Leyendas Fiscales</span>}
                    tabKey={4}
                    key={4}
                    forceRender
                  >
                    <Row>
                      <DynamicCardForm span={24} title="Complemento de Leyendas Fiscales">
                        <FormListLeyendasFiscales mostrarAviso />
                      </DynamicCardForm>
                    </Row>
                  </TabPane>
                  : null}
                <TabPane
                  tab={<span style={{ color: "#1a3a4a", fontWeight: 600, fontSize: 14 }}>Entrega</span>}
                  tabKey={3}
                  key={3}
                  forceRender
                >
                  <TabEntregaDireccion
                    loadingEntrega={this.state.loadingEntrega}
                    clienteDireccion={this.state.direccionesCliente?.[0]}
                    objetoDireccionesCliente={this.state.objetoDireccionesCliente}
                    handleChangeDireccionEntrega={this.handleChangeDireccionEntrega.bind(this)}
                    onDireccionChange={this.handleDireccionEntregaChange.bind(this)}
                    formInstance={this.formRef.current}
                    addendaMabe={this.state.addendaMabe}
                    addendaViscofan={this.state.addendaViscofan}
                    loadingPlantasEntrega={this.state.loadingPlantasEntrega}
                    objetoPlantasEntrega={this.state.objetoPlantasEntrega}
                    onSearchPlantaEntrega={this.onSearchPlantaEntrega.bind(this)}
                    objetoColonias={this.state.objetoColonias}
                    onSearchColonia={this.onSearchColonia.bind(this)}
                    onSelectColoniaId={this.onSelectColoniaId.bind(this)}
                    objetoMunicipios={this.state.objetoMunicipios}
                    onChangeMunicipio={this.onChangeMunicipio.bind(this)}
                    objetoEstados={this.state.objetoEstados}
                    onChangeEstado={this.onChangeEstado.bind(this)}
                    objetoPaises={this.state.objetoPaises}
                  />
                </TabPane>
                </Tabs>
              </div>

              {this.state.datosVenta && (
                <Row justify="end" style={{ marginTop: 16 }}>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div
                      style={{
                        background: "white",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                        borderLeft: "4px solid #FF6A0D",
                        borderTopLeftRadius: "8px",
                        borderBottomLeftRadius: "8px",
                        padding: "8px",
                        width: "100%",
                        minWidth: 0,
                        overflowX: "auto",
                      }}
                    >
                    <table className="table" style={{ marginTop: 0, fontSize: "16px" }}>
                      <tbody>
                        <tr>
                          <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>
                            Subtotal
                          </th>
                          <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                            {dineroDisabledMask(this.state.datosVenta.subtotal)}
                          </td>
                        </tr>
                      </tbody>
                      {this.state.datosVenta.arrayImpuestos.map((valueArray, index) => (
                        <tbody key={index}>
                          <tr>
                            <th className="th-totales" style={{ fontSize: "16px" }}>
                              {valueArray.descripcionFactura}
                            </th>
                            <td className="td-totales-right" style={{ fontSize: "16px" }}>
                              {dineroDisabledMask(valueArray.totalImpuestos)}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                      <tbody>
                        <tr>
                          <th className="th-totales" style={{ fontSize: "16px" }}>Total</th>
                          <td className="td-totales-right" style={{ fontSize: "16px" }}>
                            {dineroDisabledMask(this.state.datosVenta.total)}
                          </td>
                        </tr>
                      </tbody>
                      {this.state.datosVenta.arrayRetenciones.map((valueArrayRetenciones, index) => (
                        <tbody key={index}>
                          <tr>
                            <th className="th-totales" style={{ fontSize: "18px" }}>
                              {valueArrayRetenciones.descripcionFactura}
                            </th>
                            <td className="td-totales-right" style={{ fontSize: "18px" }}>
                              {dineroDisabledMask(valueArrayRetenciones.totalRetenciones)}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                      <tbody>
                        <tr>
                          <th className="th-totales" style={{ fontSize: "17px" }}>Total a Pagar</th>
                          <td className="td-totales-right" style={{ fontSize: "17px" }}>
                            {dineroDisabledMask(this.state.datosVenta.totalPagar)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                  </Col>
                </Row>
              )}

              <div className="general-form-action-buttons-wrapper">
                <div className="general-form-action-buttons">
                  <ButtonItem
                    type="primary"
                    blanco
                    onClick={this.abrirVistaPrevia.bind(this)}
                  >
                    Vista previa
                  </ButtonItem>
                  <ButtonItem
                    type="primary"
                    cyanB
                    hotkey="shift+g"
                    htmlType="submit"
                  >
                    Generar
                  </ButtonItem>
                </div>
              </div>
            </Form>
          </Spin>
        </div>
        <ElegirTipoDeCliente
          visible={this.state.modalElegirTipoDeCliente}
          id={this.state.modalElegirTipoDeClienteId}
          nombre={this.state.modalElegirTipoDeClienteNombre}
          cerrarElegirTipoDeCliente={this.cerrarElegirTipoDeCliente.bind(this)}
        />
        <MandarCorreo
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          cerrarMandarCorreo={this.cerrarMandarCorreo.bind(this)}
        />
        <VistaPreviaVenta
          visible={this.state.modalVistaPrevia}
          datosVenta={this.state.datosVistaPrevia}
          endpoint="ventas/datosPdfPreviewGenerarFactura"
          cerrarVistaPreviaVenta={() => this.setState({ modalVistaPrevia: false, datosVistaPrevia: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    complementoDetallista: state.empresa.complementoDetallista,
    complementoSeriesPersonalizadas: state.empresa.complementoSeriesPersonalizadas,
    permisoElegirSerieFolioPersonalizado:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a9b6273e58adfd453dfa6f7"
      )?.activado,
  };
};

export default connect(mapStateToProps)(GenerarFactura);
